<template>
  <ValidationObserver class="mx-auto p-3" v-slot="{ invalid }">
    <form @submit.prevent="onSubmit">
      <h5 class="mb-3 text-uppercase bg-light p-2"><i class="mdi mdi-payload-circle mr-1"></i>Information personnelle</h5>
      <div class="row">
        <div class="col-12">
          <ValidationProvider rules="image" v-slot="{ errors }">
            <div class="d-flex justify-content-center"><img :src="photo" class="img-responsive" width="100"></div>
            <div class="custom-file">
              <input type="file" ref="file" class="custom-file-input" accept="image/*" @change="onLoad"/>
              <label class="custom-file-label">Choisir la photo</label>
            </div>
            <small class="form-text text-danger">{{ errors[0] }}</small>
          </ValidationProvider>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <ValidationProvider name="Prenoms" class="form-group" rules="required" v-slot="{ errors }">
            <label>Prénoms</label>
            <input v-uppercase type="text" class="form-control" v-model="payload.prenoms" placeholder="Entrez vos prénoms" readonly>
            <small class="form-text text-danger">{{ errors[0] }}</small>
          </ValidationProvider>
        </div>
        <div class="col-md-6">
          <ValidationProvider name="Nom" class="form-group" rules="required" v-slot="{ errors }">
            <label>Nom</label>
            <input v-uppercase type="text" class="form-control" v-model="payload.nom" placeholder="Entrez votre nom" readonly>
            <small class="form-text text-danger">{{ errors[0] }}</small>
          </ValidationProvider>
        </div>
      </div>
      
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>Adresse</label>
            <textarea class="form-control" v-uppercase v-model="payload.adresse" rows="4" placeholder="Ecrivez votre adresse"></textarea>
          </div>
        </div>
      </div>
      <div>
        <div class="form-group">
          <ValidationProvider name="Email" rules="required|email" v-slot="{ errors }">
            <label>Adresse email</label>
            <input style="text-transform: lowercase;" type="email" class="form-control" v-model="payload.email" placeholder="Entrez email" readonly>
            <small class="form-text text-danger">{{ errors[0] }}</small>
          </ValidationProvider>
        </div>
      </div>
      <div class="form-group">
        <ValidationProvider name="Phone" rules="required|min:5" v-slot="{ errors }">
          <label>Numéro téléphone</label>
          <InterPhone required :preferred-countries="preferredCountries" @update="doCommit" :translations="translation" default-country-code="BJ" v-model="yourValue" />
          <!-- <input type="tel" class="form-control" v-model="payload.phone" placeholder="Entrez le numéro de téléphone"> -->
          <small class="form-text text-danger">{{ errors[0] }}</small>
          <small class="form-text text-danger" v-if="showOut">Le Pays doit être sélectionné</small>
        </ValidationProvider>
      </div>
<!--      <h5 class="mb-3 text-uppercase bg-light p-2"><i class="mdi mdi-office-building mr-1"></i> Company Info</h5>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label for="companyname">Company Name</label>
            <input type="text" class="form-control" id="companyname" placeholder="Enter company name">
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="cwebsite">Website</label>
            <input type="text" class="form-control" id="cwebsite" placeholder="Enter website url">
          </div>
        </div>
      </div>-->
      <hr/>
      <!-- <h5 class="mb-3 text-uppercase bg-light p-2"><i class="mdi mdi-earth mr-1"></i> Réseaux sociaux</h5>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label for="social-fb">Facebook</label>
            <div class="input-group"><div class="input-group-prepend"> <span class="input-group-text"><i class="fab fa-facebook-square"></i></span></div> <input type="text" class="form-control" id="social-fb" placeholder="Url"></div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="social-tw">Twitter</label>
            <div class="input-group"><div class="input-group-prepend"> <span class="input-group-text"><i class="fab fa-twitter"></i></span></div> <input type="text" class="form-control" id="social-tw" placeholder="Username"></div>
          </div>
        </div>
      </div> -->
      <!--<div class="form-group row"> <label class="col-lg-3 col-form-label form-control-label">Address</label><div class="col-lg-9"> <input class="form-control" type="text" value="" placeholder="Street"></div></div>
      <div class="form-group row"> <label class="col-lg-3 col-form-label form-control-label"></label><div class="col-lg-6"> <input class="form-control" type="text" value="" placeholder="City"></div>
        <div class="col-lg-3"> <input class="form-control" type="text" value="" placeholder="State"></div>
      </div>-->
      <div class="d-flex justify-content-end">
        <button class="style_btn text-uppercase btn btn-primary rounded-0" :disabled="invalid || showOut" v-if="!loading"><i class="mdi mdi-content-save"></i> Valider</button>
      </div>
  </form>
  </ValidationObserver>
</template>

<script>
    export default {
        name: "ProfilEdit",
        props: {account: Object},
        data: () => ({loading: false, yourValue: "",
            payload: {
              type: false,
              agence: false,
              agenceEntity: {},
              agencelabel: '',
              bank: false,
              banque: {},
              direction: false,
              fullname: false,
              isAdmin: false,
              isAgentIns: false,
              isAgentHop: false,
              isAgentBank: false,
              isAdp: false,
              isBulletinP: false,
              isBvm: false,
              isBvmPensionne: false,
              isAllocation: false,
              seeNommination: false,
              isCapital: false,
              isCessation: false,
              isControle: false,
              isDirecteur: false,
              isSuperior: false,
              isDs: false,
              isNommination: false,
              isFrais: false,
              isJustification: false,
              isReleveP: false,
              isReleveS: false,
              isSuivi: false,
              isValidation: false,
              isDeclaration: false,
              isPlainte: false,
              isAgentCheck: false,
              isDcEnfant: false,
              parent: {},
              username: '',
              id: '',
              matricule: '',
              nom: '',
              prenoms: '',
              email: '',
              login: '',
              phone: '',
              adresse: '',
              user: {},
              agent: {},
              avatar: "",
              birthDate: "",
              createdAt: null,
              hospital: {},
              ifDGB: false,
              isDPRV: false,
              nip: null,
              service: {},
              signature: null,
              session: {},
              ua: {},
              affilie: {},
              typeAcces: {}
          },
          translation: {
            countrySelectorLabel: 'Code pays',
            countrySelectorError: 'Choisir un pays',
            phoneNumberLabel: 'Numéro de téléphone',
            example: 'Exemple :'
          },
          showOut: true,
          preferredCountries: ['BJ', 'FR'],
        }),
        computed: {
            user() {
                return this.$store.getters['auth/loggedAs'];
            },
            photo() {
              return this.payload.avatar ? this.payload.avatar.includes("data:") ? this.payload.avatar : 
              `${process.env.VUE_APP_API_URL}/uploads/${this.user.avatar}`: this.user.avatar ?
              `${process.env.VUE_APP_API_URL}/uploads/${this.user.avatar}`:
                  `${process.env.VUE_APP_BASE_URL}img/profilMan.jpg`;
            },
        },
        methods: {
          doCommit(data){
            if(data?.formattedNumber){
              if(data?.formattedNumber.includes("+")) this.showOut = false;
              else this.showOut = true;
            }
            if(data?.formattedNumber) this.payload.phone = data.formattedNumber
            else this.payload.phone = null
          },
          onSubmit() {
            this.loading = true;
            this.$store.dispatch('auth/profile', this.payload)
                .then(() => this.$swat.fire('Mise à jour', 'Votre compte a été mise à jour avec succès.').then((res) => this.account = res))
                .catch(({data}) => this.$swat.fire('Erreur de Connexion', (data.message || data.error_description) || 'Sauvegarde échouée', 'error'))
                .finally(() => this.loading = false);
          },
          onLoad(value) {
            let reader = new FileReader(), files = value.target.files || value.dataTransfer.files;
            if (!files.length) return; reader.readAsDataURL(files[0]);
            reader.onload = e => this.payload.avatar = e.target.result;
          },
          
          onUpload() {
            let files = this.$refs.file.files;
            if(files.length) {
              this.$set(this.payload, 'file', files[0]);
              this.payload.file.url = URL.createObjectURL(files[0]);
            }
          },
        },
        created(){
            this.payload = {
              type: this.account.type,
              agence: this.account.agence,
              agenceEntity: this.account.agenceEntity,
              agencelabel: this.account.agencelabel,
              bank: this.account.bank,
              banque: this.account.banque,
              direction: this.account.direction,
              fullname: this.account.fullname,
              isAdmin: this.account.isAdmin,
              isAgentIns: this.account.isAgentIns,
              isAgentHop: this.account.isAgentHop,
              isAgentBank: this.account.isAgentBank,
              isAdp: this.account.isAdp,
              isBulletinP: this.account.isBulletinP,
              isBvm: this.account.isBvm,
              isBvmPensionne: this.account.isBvmPensionne,
              isAllocation: this.account.isAllocation,
              seeNommination: this.account.seeNommination,
              isCapital: this.account.isCapital,
              isCessation: this.account.isCessation,
              isControle: this.account.isControle,
              isDirecteur: this.account.isDirecteur,
              isSuperior: this.account.isSuperior,
              isDs: this.account.isDs,
              isNommination: this.account.isNommination,
              isFrais: this.account.isFrais,
              isJustification: this.account.isJustification,
              isReleveP: this.account.isReleveP,
              isReleveS: this.account.isReleveS,
              isSuivi: this.account.isSuivi,
              isValidation: this.account.isValidation,
              isDeclaration: this.account.isDeclaration,
              isPlainte: this.account.isPlainte,
              isAgentCheck: this.account.isAgentCheck,
              isDcEnfant: this.account.isDcEnfant,
              parent: this.account.parent,
              username: this.account.username,
              id: this.account.id,
              matricule: this.account.matricule,
              nom: this.account.nom,
              prenoms: this.account.prenoms,
              email: this.account.email,
              login: this.account.login,
              phone: this.account.phone,
              adresse: this.account.adresse,
              user: this.account.user,
              agent: this.account.agent,
              avatar: this.account.avatar,
              birthDate: this.account.birthDate,
              hospital: this.account.hospital,
              ifDGB: this.account.ifDGB,
              isDPRV: this.account.isDPRV,
              nip: this.account.nip,
              service: this.account.service,
              signature: this.account.signature,
              createdAt: this.account.createdAt,
              session: this.account.session,
              ua: this.account.ua,
              affilie: this.account.affilie,
              typeAcces: this.account.typeAcces,
          }
          this.yourValue = this.payload.phone;
        }
    }
</script>

<style scoped>

</style>



